import Header from "../../Header";
import {useEffect, useState} from "react";
import {Payee, PayeeAccount} from "../../Types/Payee";
import {getMyPayeeAccount} from "../../API/PayeeManager";
import tableStyle from "../../General CSS/Table.module.css";
import {useNavigate} from "react-router-dom";

export default function Account() {
    const [payee, setPayee] = useState<Payee | null>(null);
    const [defaultAccount, setDefaultAccount] = useState<PayeeAccount | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        getMyPayeeAccount()
            .then(response => {
                setPayee(response);
                setDefaultAccount(response?.accounts.find(account => account.defaultAccount) ?? null);
            })
            .catch(err => setError(err.message || "Unknown Error"))
            .finally(() => setLoading(false));
        }, []);

    return (
        <>
            <Header page={"My Account"} returnLink={"/account/overview"}/>
            <div className="content">
                { loading ? (
                    <p></p>
                ) : error ? (
                    <p>{error}</p>
                ) : payee ? (
                    <div className={tableStyle.table}>
                        <table>
                            <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{payee.name}</td>
                            </tr>
                            <tr>
                                <td>Type</td>
                                <td>{payee.payeeType}</td>
                            </tr>
                            <tr>
                                <td>First Name</td>
                                <td>{payee.firstName}</td>
                            </tr>
                            <tr>
                                <td>Last Name</td>
                                <td>{payee.lastName}</td>
                            </tr>
                            </tbody>
                        </table>

                        {defaultAccount ? (
                            <table>
                                <thead>
                                <tr>
                                    <th>Primary Account</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Sort Code</td>
                                    <td>{defaultAccount.bankIdentifier}</td>
                                </tr>
                                <tr>
                                    <td>Account Number</td>
                                    <td>{defaultAccount.accountIdentifier}</td>
                                </tr>
                                <tr>
                                    <td>Account Description</td>
                                    <td>{defaultAccount.description}</td>
                                </tr>
                                </tbody>
                            </table>
                        ) : (
                            <h3>No default account set.</h3>
                        )}
                        <button onClick={() => navigate("/account/my-account/edit")}>
                            Edit My Accounts
                        </button>
                    </div>
                ) : (
                    <div className="blank-page">
                        <h3>No account found</h3>
                        {/*<button onClick={() => navigate("/account/create-my-payee-account")}>Add My Account</button>*/}
                    </div>
                )
                }
            </div>
        </>
    )
}